import { useResetLearningJourneySessionDiscussionTeamsMutationRemote } from '@/store/v2';

/**
 * Clears a journey's learning teams.
 *
 * Delete-only: the teams go and their member rows cascade away with them, and nothing is put
 * back. The journey is left with no teams at all, so a caller has to send the admin somewhere
 * they can set them up again rather than back to a list that is now empty.
 *
 * Keyed on the journey, not the session — the server resolves the session itself, the same way
 * the team-import mutations do.
 */
export const useResetLearningJourneyDiscussionTeams = (): {
  /** Resolves to `false` when the teams were left as they were. */
  resetTeams: (journeyId: number) => Promise<boolean>;
  resetLoading: boolean;
} => {
  const [resetTeams, { loading: resetLoading }] = useResetLearningJourneySessionDiscussionTeamsMutationRemote();

  return {
    resetLoading,

    resetTeams: async (journeyId: number) => {
      const { data } = await resetTeams({
        variables: { input: { journeyId } },
        // The teams query is the only thing that read them, and it is what the page the admin
        // lands on will ask again.
        update: (cache, { data: result }) => {
          if (result?.resetLearningJourneySessionDiscussionTeams?.success) {
            cache.evict({ fieldName: 'learningJourney' });
          }
        },
      });

      return !!data?.resetLearningJourneySessionDiscussionTeams?.success;
    },
  };
};
